import React,{ useState, useRef } from 'react';
import AdminServiciosAPI from '../servicios/AdminServicios';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import Config from '../comun/Config';
import { Toast } from 'primereact/toast';

const Ruc = () => {
    const [input, setInput] = useState('');
    const [cargando, setCargando] = useState(false);
    const toast = useRef(null);
    const [deshabilitar, setDeshabilitar] = useState(false);

    const recuperarUsuario = async () => {
        setCargando(true);
        const response = await AdminServiciosAPI.postRegistro('recuperarUsuario',{ruc:input});
        if(response.ok){
            const datos = await response.json();
            if(datos.email){
                toast.current.show({severity:'success', summary: 'Revisa tu correo', detail:`Te hemos enviado un correo a ${datos.email.substring(0,4)}.....${datos.email.substring(datos.email.length-10)}`, sticky: true});
            }else{
                toast.current.show({severity:'error', summary: 'Error', detail:datos.error, sticky: true});
            }
            setDeshabilitar(true);
        }else{
            toast.current.show({severity:'error', summary: 'Problemas de conexión', detail:'Por favor intenta en unos minutos.', sticky: true});
        }
        setCargando(false);
    }

    return (
        <div>
            <Toast ref={toast} position="bottom-center" />
            <h4>Recupera tu usuario y clave</h4>
            <p>Por favor ingresa tu número de ruc y te guiaremos para recuperar tu usuario y clave.</p>
            <div className="p-field mb-4">
                <InputText id="in" className="w-100" value={input} onChange={(e) => setInput(e.target.value)} placeholder="Ingrese su ruc" keyfilter="num" />
            </div>
            <div className="d-flex justify-content-between">
                <Button disabled={input==='' || deshabilitar} className="boton-enviar w-50" label="Enviar" loading={cargando} onClick={recuperarUsuario} />
                <a className="mt-2" href={Config.dirroot}>Regresar al login</a>
            </div>
        </div>
    )
}

export default Ruc